import { BaseBetsApiClient } from "./BaseBetsApiClient";
export const BETS_ENDPOINTS = {
    PLACE_BETS: "/placeBets",
    CALCULATE_BETS: "/calculateBets",
    PRECALCULATE_BETS: "/precalculate"
};
export class BetsApiClient extends BaseBetsApiClient {
    placeBets(request) {
        let fetchOptions = {
            request
        };
        return super.executeRequest(BETS_ENDPOINTS.PLACE_BETS, fetchOptions);
    }
    calculateBets(request) {
        let fetchOptions = {
            request
        };
        return super.executeRequest(BETS_ENDPOINTS.CALCULATE_BETS, fetchOptions);
    }
    precalculateBets(request) {
        let fetchOptions = {
            request
        };
        return super.executeRequest(BETS_ENDPOINTS.PRECALCULATE_BETS, fetchOptions);
    }
}
//# sourceMappingURL=BetsApiClient.js.map